export function objectToQueryString(obj) {
  let tokens = []
  for (const [key, value] of Object.entries(obj)) {
    let queryKey = Array.isArray(value) ? key + '[]' : key
    let queryValue = typeof value === 'object' ? JSON.stringify(value) : value
    tokens.push(`${queryKey}=${queryValue}`)
  }
  return encodeURI(tokens.join('&&'))
}
